import { uniqueId } from 'lodash';
import { TempLesson } from '@/models/Lesson';
import { Temp } from '@/models/Temp';
import { Model, Ordenable } from '@/models/Model';

/**
 * @deprecated Use `Unit` from `@/models/Unit` instead.
 */
export default class LessonBlock extends Model implements Ordenable {
  id!: number;
  name: string = '';
  order!: number;

  constructor(lessonBlock?: Partial<LessonBlock>) {
    super(lessonBlock);
    Object.assign(this, lessonBlock);
  }
}

/**
 * @deprecated TempLessonBlock was removed.
 */
export class TempLessonBlock extends LessonBlock implements Temp {
  tempId?: string = uniqueId();
  lessons: TempLesson[] = [];

  constructor(lessonBlock?: Partial<TempLessonBlock>) {
    super();
    Object.assign(this, lessonBlock);
  }
}

/**
 * @deprecated MatrixBlockType was removed.
 */
export enum MatrixBlockType {
  BLOCK = 'BLOCK',
  LESSON = 'LESSON',
}

/**
 * @deprecated Use `PickUnitInfo` from `@/models/Unit` instead.
 */
export type PickLessonBlockInfo = Pick<LessonBlock, 'name' | 'order'>;
